import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@copro/api";

async function postDocuments(ids: string[]) {
  const { error } = await apiClient
    .from('documents')
    .delete()
    .in('id', ids)

  if (error) {
    throw error
  }
}

export function useDeleteDocuments() {
  return useMutation({
    mutationFn: async (variables: { ids: string[] }) => postDocuments(variables.ids)
  })
}
